import React from "react";
import { Listbox, ListboxOption } from "@reach/listbox";
import "@reach/listbox/styles.css";
import { createUseStyles, useTheme } from "react-jss";
import clsx from "clsx";
import DoubleArrowIcon from "./icons/DoubleArrowIcon";
import useMediaQuery from "../hooks/useMediaQuery";
var useStyles = createUseStyles({
    dropdown: {
        fontSize: function (_a) {
            var isLarge = _a.isLarge;
            return isLarge ? "24px" : "18px";
        },
        backgroundColor: "#1D1F4266",
        borderRadius: [5, 5, 0, 0],
        borderBottom: "3px solid #0378CD",
        color: "white",
        "& [data-reach-listbox-button]": {
            border: "none",
            padding: function (_a) {
                var isLarge = _a.isLarge;
                return isLarge ? 20 : 12;
            },
            width: "100%",
            wordBreak: "break-word"
        },
    },
    option: {
        backgroundColor: "#1D1F42",
        color: "white"
    },
    "@global": {
        "[data-reach-listbox-popover]": {
            backgroundColor: "#1D1F42 !important",
        }
    }
});
var Dropdown = function (props) {
    var _a;
    var theme = useTheme();
    var isLarge = useMediaQuery(theme.breakpoints.up("lg"));
    var classes = useStyles({ isLarge: isLarge });
    return (React.createElement(Listbox, { defaultValue: props.value, onChange: props.onChange, className: clsx(props.className, classes.dropdown), arrow: (_a = props.arrow) !== null && _a !== void 0 ? _a : React.createElement(DoubleArrowIcon, null) }, React.Children.map(props.children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                className: classes.option
            });
        }
        return child;
    })));
};
export var DropdownOption = ListboxOption;
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map